export const SET_NAVIGATOR_VIEW = 'SET_NAVIGATOR_VIEW';

export const FETCH_NAV_ATHLETES_START = 'FETCH_NAV_ATHLETES_START';
export const FETCH_NAV_ATHLETES_FULFILLED = 'FETCH_NAV_ATHLETES_FULFILLED';
export const FETCH_NAV_ATHLETES_REJECTED = 'FETCH_NAV_ATHLETES_REJECTED';

export const FETCH_NAV_ATHLETE_ASSIGNMENTS_START = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_START';
export const FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED';
export const FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED = 'FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED';

export const FETCH_NAV_CALENDARS_START = 'FETCH_NAV_CALENDARS_START';
export const FETCH_NAV_CALENDARS_FULFILLED = 'FETCH_NAV_CALENDARS_FULFILLED';
export const FETCH_NAV_CALENDARS_REJECTED = 'FETCH_NAV_CALENDARS_REJECTED';

export const FETCH_NAV_CALENDAR_ITEMS_START = 'FETCH_NAV_CALENDAR_ITEMS_START';
export const FETCH_NAV_CALENDAR_ITEMS_FULFILLED = 'FETCH_NAV_CALENDAR_ITEMS_FULFILLED';
export const FETCH_NAV_CALENDAR_ITEMS_REJECTED = 'FETCH_NAV_CALENDAR_ITEMS_REJECTED';

export const FETCH_NAV_CALENDAR_PREVIEW_START = 'FETCH_NAV_CALENDAR_PREVIEW_START';
export const FETCH_NAV_CALENDAR_PREVIEW_FULFILLED = 'FETCH_NAV_CALENDAR_PREVIEW_FULFILLED';
export const FETCH_NAV_CALENDAR_PREVIEW_REJECTED = 'FETCH_NAV_CALENDAR_PREVIEW_REJECTED';

export const FETCH_NAV_PROGRAMS_START = 'FETCH_NAV_PROGRAMS_START';
export const FETCH_NAV_PROGRAMS_FULFILLED = 'FETCH_NAV_PROGRAMS_FULFILLED';
export const FETCH_NAV_PROGRAMS_REJECTED = 'FETCH_NAV_PROGRAMS_REJECTED';

export const FETCH_NAV_PROGRAM_ITEMS_START = 'FETCH_NAV_PROGRAM_ITEMS_START';
export const FETCH_NAV_PROGRAM_ITEMS_FULFILLED = 'FETCH_NAV_PROGRAM_ITEMS_FULFILLED';
export const FETCH_NAV_PROGRAM_ITEMS_REJECTED = 'FETCH_NAV_PROGRAM_ITEMS_REJECTED';

export const FETCH_NAV_PROGRAM_DAY_ONE_START = 'FETCH_NAV_PROGRAM_DAY_ONE_START';
export const FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED = 'FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED';
export const FETCH_NAV_PROGRAM_DAY_ONE_REJECTED = 'FETCH_NAV_PROGRAM_DAY_ONE_REJECTED';

export const FETCH_NAV_PROGRAM_PREVIEW_START = 'FETCH_NAV_PROGRAM_PREVIEW_START';
export const FETCH_NAV_PROGRAM_PREVIEW_FULFILLED = 'FETCH_NAV_PROGRAM_PREVIEW_FULFILLED';
export const FETCH_NAV_PROGRAM_PREVIEW_REJECTED = 'FETCH_NAV_PROGRAM_PREVIEW_REJECTED';

export const FETCH_NAV_WORKOUT_RESULTS_START = 'FETCH_NAV_WORKOUT_RESULTS_START';
export const FETCH_NAV_WORKOUT_RESULTS_FULFILLED = 'FETCH_NAV_WORKOUT_RESULTS_FULFILLED';
export const FETCH_NAV_WORKOUT_RESULTS_REJECTED = 'FETCH_NAV_WORKOUT_RESULTS_REJECTED';

export const FETCH_NAV_DAY_WORKOUT_ITEMS_START = 'FETCH_NAV_DAY_WORKOUT_ITEMS_START';
export const FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED = 'FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED';
export const FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED = 'FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED';

export const SET_IS_PREVIEW_CAROUSEL_SHOWING = 'SET_IS_PREVIEW_CAROUSEL_SHOWING';
